var flag = {
  "dlsFlag": {
    "backgroundSize": "cover",
    "display": "inline-block",
    "fontSize": "0",
    "height": "4.3125rem",
    "outline": "1px solid #97999b",
    "width": "6.25rem"
  },
  "dlsFlag_img": {
    "verticalAlign": "top",
    "width": "100%"
  },
  "flagSm": {
    "height": "0.6875rem",
    "width": "1rem"
  },
  "flagMd": {
    "height": "2.1875rem",
    "width": "3.125rem"
  }
};

export default flag;
